import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  modals: [
    {
      id: "UpdateDep",
      open: false,
      data: [],
    },
    {
      id: "UpdateModal",
      open: false,
      data: [],
    },
    {
      id: "UpdateUserModal",
      open: false,
    },

    {
      id: "AddHolyModal",
      open: false,
    },
    {
      id: "EmpDetModal",
      open: false,
      data: false,
    },

    {
      id: "AddEmplFoms",
      open: false,
    },
    {
      id: "ApplyForLeave",
      open: false,
    },
    {
      id: "AddNewDepModal",
      open: false,
    },
    {
      id: "ApplyForNegotiationModal",
      open: false,
    },
    {
      id: "LeaveSettingsModal",
      open: false,
    },
    {
      id: "ApplyForLeaveDetailsModal",
      open: false,
    },
    {
      id: "UpdateLeaveSettingsModal",
      open: false,
    },
    {
      id: "confirm-delete-modal",
      open: false,
    },
    {
      id: "ConfirmDeleteModal",
      open: false,
    },
    {
      id: "ConfirmDeletePerGrpModal",
      open: false,
    },
    {
      id: "RejectLeaveRequestModal",
      open: false,
    },
    {
      id: "ApplyForAuthorisationModal",
      open: false,
    },
    {
      id: "ApplyForAuthorisationModalDetails",
      open: false,
    },
    {
      id: "editPasswordModal",
      open: false,
    },
    {
      id: "EditPasswordModal",
      open: false,
    },

    {
      id: "uploadFile",
      open: false,
    },
    {
      id: "HeadquarterForm",
      open: false,
    },
    {
      id: "RejectRemoteRequestModal",
      open: false,
      data: null,
    },
    {
      id: "ApplyForRemoteRequestModal",
      open: false,
    },
    {
      id: "ApplyForRemoteRequestFormModal",
      open: false,
    },
    {
      id: "ConfirmResetModal",
      open: false,
      data: null,
    },
  ],
};

const slice = createSlice({
  name: "modals",
  initialState,
  reducers: {
    openModal: (state, action) => {
      const { id, data } = action.payload;
      const index = state.modals.findIndex((modal) => modal.id === id);
      if (index !== -1) {
        state.modals[index].open = true;
        state.modals[index].data = data;
      } else {
        console.error("❌ Modal not found:", id);
      }
    },
    closeModal: (state, action) => {
      const id = action.payload;
      const index = state.modals.findIndex((modal) => modal.id === id);
      if (index !== -1) {
        state.modals[index].open = false;
      } else {
        console.error("❌ Modal not found for closing:", id);
      }
    },
  },
});

export const reducer = slice.reducer;

export const openModal = (id, data) => (dispatch) => {
  dispatch(slice.actions.openModal({ id, data }));
};

export const closeModal = (id) => (dispatch) => {
  dispatch(slice.actions.closeModal(id));
};

export default slice;
